import { logger } from '@/util/logger';

const $ = window.$;

export default function(id) {
	this.id = id || 'queue-' + Date.now();
	var _indexMap = {};
	var _handlerList = [];
	var _DEFAULT_NAMESPACE = 'window';
	var that = this;

	var _buildHandlerReference = function(funcName, context) {
		// builds a reference to the handler so it can be reconstructed and applied later
		if (typeof funcName !== 'string') throw new Error('parameter "funcName" must be of type "string"');

		if (typeof context === 'object' && typeof context[funcName] !== 'function') throw new Error(funcName + ' is not a property of specified context');

		var handlerID = _getHandlerId(funcName, context);

		return {
			id: handlerID,
			handler: funcName,
			context: context || null,
			arguments: arguments,
			inactive: false
		};
	};

	var _updateReferenceMap = function() {
		// reset the reference map from the handler list
		_indexMap = {};
		_handlerList.forEach(function(obj, i) {
			_indexMap[obj.id] = i;
		});
	};

	var _deferredInserts = [];

	var _buildDeferredInsert = function(type, target, funcName, context) {
		var obj = {};
		obj.funcName = funcName;
		obj.context = context;
		obj.target = target;
		obj.insertType = type;

		_deferredInserts.push(obj);
	};

	var _processDeferredInserts = function() {
		if (!_deferredInserts.length) return;

		_deferredInserts.forEach(function(obj) {
			var insertIndex = _indexMap[_getHandlerId(obj.target)];
			if (typeof insertIndex === 'undefined') {
				that.add(obj.funcName, obj.context);
				logger.warn('could not insert ' + obj.funcName + ' before ' + obj.target + ' because target is not a member of ' + that.id);
				return;
			}
			if (obj.insertType === 'before') {
				that.insertBefore(obj.target, obj.funcName, obj.context);
			} else {
				that.insertAfter(obj.target, obj.funcName, obj.context);
			}
		});
	};

	var _getHandlerId = function(funcName, context) {
		var name = '';
		if (typeof context === 'object' && context.id) {
			name += context.id + '-';
		} else {
			name += _DEFAULT_NAMESPACE + '-';
		}

		name += funcName;

		return name;
	};

	this.viewList = function() {
		// list handler ids in order for debugging

		var arr = [];

		_handlerList.forEach(function(obj) {
			arr.push(obj.id);
		});
	};

	this.add = function(funcName, context) {
		context = context || window;

		var obj = _buildHandlerReference(funcName, context);

		// add to end of queue or update enqueued function
		if (typeof _indexMap[obj.id] !== 'undefined') {
			var index = _indexMap[obj.id];
			_handlerList[index] = obj;
		} else {
			_handlerList.push(obj);

			_indexMap[obj.id] = _handlerList.length - 1;
		}
	};

	this.remove = function(funcName, context) {
		var handlerId = _getHandlerId(funcName, context);
		var index = _indexMap[handlerId];

		if (index && index > -1) {
			_handlerList[index].inactive = true;
		}
	};

	this.insertAfter = function(name, funcName, context) {
		var insertIndex = _indexMap[_getHandlerId(name)];

		if (typeof insertIndex === 'undefined') {
			_buildDeferredInsert('after', name, funcName, context);
			return;
		}

		var obj = _buildHandlerReference(funcName, context);

		if (typeof _indexMap[obj.id] !== 'undefined') {
			// update existing function
			_handlerList[_indexMap[obj.id]] = obj;
		} else {
			_handlerList.splice(insertIndex + 1, 0, obj);
		}

		_updateReferenceMap();
	};

	this.insertBefore = function(name, funcName, context) {
		var insertIndex = _indexMap[_getHandlerId(name)];

		if (typeof insertIndex === 'undefined') {
			_buildDeferredInsert('before', name, funcName, context);
			return;
		}

		var obj = _buildHandlerReference(funcName, context);
		if (typeof _indexMap[obj.id] !== 'undefined') {
			// update existing function
			_handlerList[_indexMap[obj.id]] = obj;
		} else if (insertIndex !== 'undefined') {
			_handlerList.splice(insertIndex - 1, 0, obj);
		} else {
			_handlerList.push(obj);
		}

		_updateReferenceMap();
	};

	this.test = function() {};
	this.run = function() {
		var i = 0;
		var obj;

		// Execute all enqueued handlers in order.
		do {
			obj = _handlerList[i];

			if (obj && !obj.inactive) {
				obj.context[obj.handler].apply(obj.context);
			}
			i++;
		} while (i < _handlerList.length);

	};

	$(window).on('load', function () {
		// process deferred inserts after load, by which time all handlers will be attached.
		_processDeferredInserts.call(that);
	});
}